export var LANGUAGE = 'es';
